import VueRouter from 'vue-router'
import Vue from 'vue'
Vue.use(VueRouter)

const Home = () => import('./views/Home.vue');
const Empty = () => import('./views/Empty.vue');
const HomeMain = () => import('./views/Home/Main.vue');
const CollectUserList = () => import('./views/Home/Collect/User/List.vue');
const UserTagList = () => import('./views/Home/Collect/User/Tag/List.vue');
const CollectTopicList = () => import('./views/Home/Collect/Topic/List.vue');
const CollectPostList = () => import('./views/Home/Collect/Post/List.vue');
const CollectTaskList = () => import('./views/Home/Collect/Task/List.vue');

const Login = () => import('./views/Login.vue');
const PageNotFound = () => import('./views/PageNotFound.vue');

const routes = [
  { path: '/Home', component: Home, children:[

    { path: 'Main', component: HomeMain, meta: { title: "主页", icon: "el-icon-s-home", isMenu:true }},
    {
      path: 'Collect', component: Empty, meta: { title: "采集", icon: "el-icon-star-on", isMenu: true }, children:[
        { path: 'User/List', component: CollectUserList, meta: { title: "用户管理", isMenu: true }},
        { path: 'User/List/Tag/:tagName', component: CollectUserList, meta: { title: "用户管理", isMenu: false }},
        { path: 'User/Tag/List', component: UserTagList, meta: { title: "标签管理", isMenu: true }},
        { path: 'Topic/List', component: CollectTopicList, meta: { title: "话题管理", isMenu: false }},
        { path: 'Post/List', component: CollectPostList, meta: { title: "帖子发布管理", isMenu: false }},
        { path: 'Task/List', component: CollectTaskList, meta: { title: "采集任务日志", isMenu: true }},
    ]},
    { path: '*', component: PageNotFound },

  ]},
  { path: '/Login', component: Login, meta: { title:"登录",isLoginPage: true}},
  {path:'*', component: PageNotFound},
]

const MainRouter = new VueRouter({
  mode: 'hash',
  routes,
})

MainRouter.beforeEach((to, from, next) => {
  console.log(to, from);
  const token = window.localStorage.getItem("token");

  if (token){
    if (to.path == '/' || to.matched.some(record => record.meta.isLoginPage)) {
      next({
        path: '/Home/Main'
      });
    } else {
      if (to.path == '/Home') {
        next({
          path: '/Home/Main'
        });
      }else{
        next();
      }
      
    }
  } else{
    if (to.matched.some(record => record.meta.isLoginPage)) {  
      next();
    } else {
      next({
        path: '/Login',
        query: { redirect: to.fullPath } 
      })
    }
  }
  
});

function scrollAnimation(currentY, targetY) {
  // 计算需要移动的距离
  let needScrollTop = targetY - currentY
  let _currentY = currentY
  setTimeout(() => {
    // 一次调用滑动帧数，每次调用会不一样
    const dist = Math.ceil(needScrollTop / 10)
    _currentY += dist
    window.scrollTo(_currentY, currentY)
    // 如果移动幅度小于十个像素，直接移动，否则递归调用，实现动画效果
    if (needScrollTop > 10 || needScrollTop < -10) {
      scrollAnimation(_currentY, targetY)
    } else {
      window.scrollTo(_currentY, targetY)
    }
  }, 1)
}

const title = window.document.title.replace("Loading - ","");
MainRouter.afterEach(to => {
  var temp = [];
  if (to.matched){
    to.matched.forEach(m=>{
      if(m.meta && m.meta.title){
        temp.push(m.meta.title);
      }
    });
  }
  window.document.title = temp.length > 0 ? temp.join(" / ") + " - " + title : title;
  scrollAnimation(window.scrollY,0);
})
export default MainRouter;